// extracted by mini-css-extract-plugin
module.exports = {"simpleNav":"SimpleNav_simpleNav__cvk82","simpleNav__backBtn":"SimpleNav_simpleNav__backBtn__GaB9W","simpleNav__logo":"SimpleNav_simpleNav__logo__k8uAK"};